<template>
  <mdb-container style="margin-top: 6em">
    <section class="text-justify text-monospace my-5">
      <h2 class="h1-responsive font-weight-bold my-5 text-center">联邦创业移民(Start-up Visa)</h2>
      <p class="w-responsive mx-auto mb-5">
        <span class="mr-4"></span>加拿大联邦创业移民(Start-up Visa)始于2013年，是联邦政府制定的商业类移民项目之一。加拿大政府设立此项目的是为了吸引海外人才和企业家到加拿大创办企业、创造就业，从而刺激加拿大经济增长。
        此项目替代了2012年以前的联邦投资移民项目和企业家移民项目，是移民制度的重大改革。通过此项目，申请人可以一步到位获得枫叶卡，同时不受任何限制地在加拿大境内任何地方居住、生活。

      </p>
      <mdb-row class="">
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/1.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请要求</h4>
            <p>1. 全日制大学 专科及以上学历</p>
            <p>2. 英语成绩达到CLB5</p>
            <p>3. 充足的创业资金（依据商业计划）及安家资金</p>
            <p>4. 申请人及随行家庭成员身体健康</p>
            <p>5. 申请人有合格的生意</p>
            <p>6. 获得加拿大移民局指定机构的支持信</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/7.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">项目优势</h4>
            <p>1、对申请人的学历和工作经验无硬性要求</p>
            <p>2、申请文件简单，无需解释资产来源、无个税要求</p>
            <p>3、申请流程简单，无需省里审批、一步到位获得永居</p>
            <p>4、申请周期明显优于其他商业类别永居签证项目</p>
            <p>5、可在任何地区居住，且获得永居身份后没有任何附加条件</p>
          </mdb-card-body>
        </mdb-col>
        <mdb-col lg="4" md="12" class="mb-lg-0 mb-4">
          <mdb-view class="overlay rounded z-depth-1">
            <img src="../assets/images/ca/6.jpg" alt="sample photo" class="img-fluid"/>
            <a>
              <mdb-mask waves overlay="white-slight"/>
            </a>
          </mdb-view>
          <mdb-card-body class="pb-0">
            <h4 class="font-weight-bold my-3 text-center">申请流程</h4>
            <p>1、对申请人资格免费进行评估</p>
            <p>2、确定申请人符合项目要求后签约</p>
            <p>3、根据客户背景提炼商业概念，并完成商业计划</p>
            <p>4、获得移民局认可的投资机构或者孵化器的支持信</p>
            <p>5、向加拿大移民局递交工签申请和移民申请</p>
            <p>6、获得工作签证并登陆加拿大</p>
            <p>7、获得预登陆信和体检通知</p>
            <p>8、获得移民签证，并进而获得枫叶卡</p>
          </mdb-card-body>
        </mdb-col>
      </mdb-row>
    </section>
  </mdb-container>
</template>

<script>
  export default {
    name: 'CaSuv'
  }
</script>

<style scoped>

</style>
